import { datadogLogs } from '@datadog/browser-logs';
import { initBrowserRum } from '@smg-real-estate/browser-rum';
import { interceptHydrationWarnings } from './helpers/vueHydrationReporting';

export const initDataDog = () => {
  const env = import.meta.env.VUE_APP_ENVIRONMENT;
  if (!['test', 'prod'].includes(env)) return;

  const service = `${import.meta.env.VUE_APP_PLATFORM}-layout-solution-vue`;
  const clientToken = import.meta.env.VUE_DATADOG_CLIENT_TOKEN;

  if (clientToken) {
    datadogLogs.init({
      clientToken,
      service,
      env,
      site: 'datadoghq.eu',
      forwardErrorsToLogs: false,
      sessionSampleRate: 1,
    });
  }

  const rumClientToken = import.meta.env.VUE_DATADOG_RUM_CLIENT_TOKEN;
  const applicationId = import.meta.env.VUE_DATADOG_RUM_APPLICATION_ID;

  if (rumClientToken && applicationId) {
    initBrowserRum({
      applicationId: applicationId,
      clientToken: rumClientToken,
      service,
      env,
      version: import.meta.env.VUE_COMMIT_SHA,
      sessionSampleRate: 1, // 1%
      sessionReplaySampleRate: 0,
      customAttributes: {
        platform: import.meta.env.VUE_APP_PLATFORM,
      },
      enabled: true,
    });

    interceptHydrationWarnings();
  }
};
